// import React, { useState, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import { 
//   Container, Tabs, Tab, Box, Button, Dialog, DialogActions, DialogContent, 
//   DialogContentText, DialogTitle, useTheme
// } from "@mui/material";
// import AddPersonal from "./AppPersonalDetails.jsx";
// import AddAddress from "../HRAddress/AppAddressDetails.jsx";
// import AddBankDetails from "../HRAddress/AppBankDetails.jsx";
// import AddDocument from "../HRDocument/AppDocument.jsx";
// import AddQualification from "../HRQualification/AppQualificationDetails.jsx";
// import AddWork from "../HRWorkExperience/AppWorkExperience.jsx";
// import AddEmergency from "../HREmergencyContact/AppEmergencyContact.jsx";
// import PayrollPage from "../../../../../scenes/payroll/PayrollPage.js";

// const sections = [
//   { label: "Personal Details", component: AddPersonal, key: "personalDetails" },
//   { label: "Address Details", component: AddAddress, key: "addressDetails" },
//   { label: "Document Details", component: AddDocument, key: "documentDetails" },
//   { label: "Qualification Details", component: AddQualification, key: "qualificationDetails" },
//   { label: "Work Experience", component: AddWork, key: "workExperience" },
//   { label: "Emergency Contact", component: AddEmergency, key: "emergencyContact" },
//   { label: "Bank Details", component: AddBankDetails, key: "bankDetails" },  
//   { label: "Payroll Details", component: PayrollPage , key: "payrolldetails" },  
// ];

// const AddEmployee = () => {
//     const theme = useTheme();
//     const navigate = useNavigate();
//     const [activeTab, setActiveTab] = useState(0);
//     const [isDirty, setIsDirty] = useState(false);
//     const [openDialog, setOpenDialog] = useState(false);

//     const [tempEmployeeData, setTempEmployeeData] = useState(
//       sections.reduce((acc, section) => ({ ...acc, [section.key]: {} }), {})
//     );

//     // Refs for each section
//     const componentRefs = {
//       personalDetails: useRef(null),
//       addressDetails: useRef(null),
//       documentDetails: useRef(null),
//       qualificationDetails: useRef(null),
//       workExperience: useRef(null),
//       emergencyContact: useRef(null),
//       bankDetails: useRef(null),
//       payrolldetails:useRef(null)
//     };

//     const handleTabChange = (event, newValue) => {
//       setActiveTab(newValue);
//     };

//     // Function to update temporary state when fields change
//     const handleFieldChange = (section, field, value) => {
//       setTempEmployeeData((prev) => ({
//         ...prev,
//         [section]: { ...prev[section], [field]: value },
//       }));

//       personalDetails: { corporate_email_id: "" } 
//       setIsDirty(true);
//     };

//     const handleSave = async () => {
//       try {
//           const results = await Promise.all(
//               Object.values(componentRefs).map(async (ref) => {
//                   if (ref.current && typeof ref.current.handleSubmit === "function") {
//                       return await ref.current.handleSubmit();
//                   }
//                   return null; // Skip if no handleSubmit function exists
//               })
//           );

//           console.log("All section data saved:", results);

//           if (results.includes(false)) {
//               alert("Fill required fields first");
//               return;
//           }

//           setIsDirty(false);
//           setOpenDialog(true);
//       } catch (error) {
//           console.error("Error saving employee details:", error);
//       }
//     };

//     const handleCloseDialog = () => {
//       setOpenDialog(false);
//       navigate(-1);  
//     };

//     return (
//       <Container sx={{ mt: 4 }}>
//         <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
//         <Tabs
//           value={activeTab}
//           onChange={handleTabChange}
//           variant="scrollable"
//           scrollButtons="auto"
//           sx={{
//             ".MuiTab-root": {
//               color: theme.palette.mode === "dark" ? "lightgray" : "black",
//               transition: "color 0.3s ease-in-out",
//               fontWeight: "500",
//             },
//             ".Mui-selected": {
//               color: `${theme.palette.mode === "dark" ? "white !important" : "black !important"}`,
//               fontWeight: "bold",
//               borderBottom: `3px solid ${theme.palette.mode === "dark" ? "white" : theme.palette.primary.main}`,
//             },
//             "& .MuiTabs-indicator": {
//               backgroundColor: theme.palette.mode === "dark" ? "white" : theme.palette.primary.main,
//             },
//           }}
//         >
//           {sections.map((section, index) => (
//             <Tab
//               key={index}
//               label={section.label}
//               sx={{
//                 textTransform: "none",
//                 fontSize: "0.95rem",
//                 "&:hover": {
//                   color: theme.palette.mode === "dark" ? "#B0BEC5" : theme.palette.primary.dark,
//                 },
//                 color: activeTab === index ? "white !important" : "inherit", // Ensures selected tab text remains white
//               }}
//             />
//           ))}
//         </Tabs>
//         <Button
//           variant="contained"
//           onClick={handleSave}
//           sx={{
//             bgcolor: "green",      
//             color: "white",        
//             '&:hover': {
//               bgcolor: "#9daab7",  
//             },
//           }}
//         >
//           Save
//         </Button>

//         </Box>

//         <Box sx={{ mt: 3 }}>
//           {sections.map(({ key, component: Component }, index) => (
//             <div key={key} style={{ display: activeTab === index ? "block" : "none" }}>
//                 <Component
//                     ref={componentRefs[key]}
//                     initialData={tempEmployeeData[key]}
//                     handleFieldChange={handleFieldChange}
//                     setIsDirty={setIsDirty}
//                 />
//             </div>
//           ))}
//         </Box>

//         {/* Success Dialog */}
//         <Dialog open={openDialog} onClose={handleCloseDialog}>
//           <DialogTitle sx={{ bgcolor: theme.palette.mode === "dark" ? "white" : "#f5f5f5", color: theme.palette.mode === "dark" ? "white" : "black" }}>
//             Success
//           </DialogTitle>
//           <DialogContent sx={{ bgcolor: theme.palette.mode === "dark" ? "white" : "#f5f5f5" }}>
//             <DialogContentText sx={{ color: theme.palette.mode === "dark" ? "black" : "black" }}>
//               Employee details have been successfully added!
//             </DialogContentText>
//           </DialogContent>
//           <DialogActions sx={{ bgcolor: theme.palette.mode === "dark" ? "white" : "#f5f5f5" }}>
//           <Button
//           onClick={handleCloseDialog}
//           autoFocus
//           sx={{
//             bgcolor: "#446d9c",  
//             color: "white",          
//             '&:hover': {
//               bgcolor: "#9daab7", 
//             },
//           }}
//         >
//           OK
//         </Button>

//           </DialogActions>
//         </Dialog>

//       </Container>
//     );
// };

// export default AddEmployee;



  import React, { useState} from "react";
  import { useNavigate,useParams } from "react-router-dom";
  import ArrowBackIcon from "@mui/icons-material/ArrowBack";
  import { 
    Container, Tabs, Tab, Box, Button, Dialog, DialogActions, DialogContent, 
    DialogContentText, DialogTitle, useTheme,IconButton,Typography
  } from "@mui/material";
  import AddPersonal from "./personaldetails.jsx";
  import AddAddress from "../HRAddress/AppAddressDetails.jsx";
  import AddBankDetails from "../HRAddress/AppBankDetails.jsx";
  import AddDocument from "../HRDocument/AppDocument.jsx";
  import AddQualification from "../HRQualification/AppQualificationDetails.jsx";
  import AddWork from "../HRWorkExperience/AppWorkExperience.jsx";
  import AddEmergency from "../HREmergencyContact/AppEmergencyContact.jsx";
  import PayrollPage from "../../../../../scenes/payroll/PayrollPage.js";
  // import { db } from "../../../../../firebaseConfig.js";
  // import { doc, getDoc } from "firebase/firestore";
  import Tab_PayrollPage from "../../../../../scenes/payroll/Tab_PayrollPage.js";
  import { Snackbar, Alert } from "@mui/material";

  const sections = (id) =>  [
    { label: "Personal Details", component: AddPersonal, key: "personalDetails" },
    { label: "Address Details", component: AddAddress, key: "addressDetails" },
    { label: "Document Details", component: AddDocument, key: "documentDetails" },
    { label: "Qualification Details", component: AddQualification, key: "qualificationDetails" },
    { label: "Work Experience", component: AddWork, key: "workExperience" },
    { label: "Emergency Contact", component: AddEmergency, key: "emergencyContact" },
    { label: "Bank Details", component: AddBankDetails, key: "bankDetails" },  
    {
      label: "Payroll Details",
      component: id ? Tab_PayrollPage : PayrollPage,
      key: "payrolldetails",
    },
  ];

  const AddEmployee = () => {
      const theme = useTheme();
      const navigate = useNavigate();
      const [activeTab, setActiveTab] = useState(0);
      const [isDirty, setIsDirty] = useState(false);
      const { employeeId } = useParams();
      const [openDialog, setOpenDialog] = useState(false);
      const [corporateEmail, setCorporateEmail] = useState("");
      const [message, setMessage] = useState("");
      const [messageType, setMessageType] = useState("success"); // 'success' or 'error'
      const [showMessage, setShowMessage] = useState(false);
      const [tempEmployeeData, setTempEmployeeData] = useState(
        sections(employeeId).reduce((acc, section) => ({ ...acc, [section.key]: {} }), {})
      );

      // Refs for each section
      const componentRefs = {
        personalDetails: React.useRef(),
        addressDetails: React.useRef(),
        documentDetails: React.useRef(),
        qualificationDetails: React.useRef(),
        workExperience: React.useRef(),
        emergencyContact: React.useRef(),
        bankDetails: React.useRef(),
        payrolldetails: React.useRef(),
      };

        const [employeeData, setEmployeeData] = useState({
          personalDetails: {}, 
          addressDetails: {}, 
          documentDetails: {},
          qualificationDetails: {},
          workExperience: {},
          emergencyContact: {},
          bankDetails: {},
          payrollDetails: {}
        });

      
              
        // Store Tab_PayrollPage state separately
        const [payrollState, setPayrollState] = useState({
          earnings: [],
          deductions: [],
          earningValues: {},
          deductionValues: {},
          existingPayroll: null,
          selectedDate: ""
        });

        // useEffect(() => {
        //   const fetchEmployeeData = async () => {
        //     try {
        //       if (!employeeId) return;
        //       const personalDoc = await getDoc(doc(db, "tbl_employee_personal_details", employeeId));
        //       const addressDoc = await getDoc(doc(db, "tbl_employee_address", employeeId));
        //       const bankDoc = await getDoc(doc(db, "tbl_employee_bank_details", employeeId));
        //       setEmployeeData(prev => ({
        //         ...prev,
        //         personalDetails: personalDoc.exists() ? personalDoc.data() : {},
        //         addressDetails: addressDoc.exists() ? addressDoc.data() : {},
        //         bankDetails: bankDoc.exists() ? bankDoc.data() : {},  
        //       }));
        //     } catch (error) {
        //       console.error("Error fetching data:", error);
        //     }
        //   };

        //   fetchEmployeeData();
        // }, [employeeId]);


      const handleFieldChange = (section, field, value) => {
        setTempEmployeeData((prev) => ({
          ...prev,
          [section]: { ...prev[section], [field]: value },
        }));
        
        // Capture corporate email when it changes
        if (section === "personalDetails" && field === "corporate_email_id") {
          setCorporateEmail(value);
        }
        
        setIsDirty(true);
      };

      const handleSave = async () => {
        try {
          const allKeys = Object.keys(componentRefs);

          for (let key of allKeys) {
            const ref = componentRefs[key];
            if (ref.current) {
              const validateFn =
                ref.current.validatePersonal || ref.current.validate || (() => true);
              const isValid = await validateFn();
              if (!isValid) {
                const tabIndex = sections(employeeId).findIndex(sec => sec.key === key);
                setActiveTab(tabIndex);
                setMessage(`Please complete ${key.replace(/([A-Z])/g, " $1").trim()} before saving.`);
                setMessageType("error");
                setShowMessage(true);
                return;
              }
            }
          }
          const personalRef = componentRefs["personalDetails"];
          let corporateEmail = "";
          if (personalRef?.current?.savePersonal) {
            console.log("Saving personal details...");
             const result = await personalRef.current.savePersonal();
            if (!result?.success) {
              const tabIndex = sections(employeeId).findIndex(sec => sec.key === "personalDetails");
              setActiveTab(tabIndex); 
              setMessage(result?.message || "Failed to save personal details.");
              setMessageType("error");
              setShowMessage(true);
              return;
            }

            corporateEmail = result.email;
          }


          const otherTabKeys = allKeys.filter((key) => key !== "personalDetails");
          for (let key of otherTabKeys) {
            const ref = componentRefs[key];
            if (ref.current) {
              const saveFn = ref.current.save ||ref.current.savedata || (() => true);
              if (saveFn === (() => true)) {
              }
              const saved = await saveFn(corporateEmail); 
              if (!saved) {
                const tabIndex = sections(employeeId).findIndex(sec => sec.key === key);
                setActiveTab(tabIndex);
                setMessage(`Failed to save ${key.replace(/([A-Z])/g, " $1").trim()}.`);
                setMessageType("error");
                setShowMessage(true);
                return;
              }
            }
          }
          // All success
          setMessage("All details saved successfully!");
          setMessageType("success");
          setShowMessage(true);
          setIsDirty(false);
          setOpenDialog(true);
          navigate("/material/EmpList");
        } catch (error) {
          console.error("Error saving details:", error);
          setMessage("An error occurred while saving details.");
          setMessageType("error");
          setShowMessage(true);
        }
      };



      const handleUpdate = async () => {
        
        try {
            const allKeys = Object.keys(componentRefs);
            for (let key of allKeys) {
              const ref = componentRefs[key];
              if (ref.current) {
                const validateFn =
                  ref.current.validatePersonal || ref.current.validate || (() => true);
                const isValid = await validateFn();
                if (!isValid) {
                  const tabIndex = sections(employeeId).findIndex(sec => sec.key === key);
                  setActiveTab(tabIndex);
                  setMessage(`Please complete ${key.replace(/([A-Z])/g, " $1").trim()} before saving.`);
                  setMessageType("error");
                  setShowMessage(true);
                  return;
                }
              }
            }
              const personalRef = componentRefs["personalDetails"];
              if (personalRef?.current?.savePersonal) {
                console.log("Saving personal details...");
                const success = await personalRef.current.savePersonal();

                if (!success) {
                  setMessage("Failed to save personal details.");
                  setMessageType("error");
                  setShowMessage(true);
                  return;
                }

              }
            const otherTabKeys = allKeys.filter((key) => key !== "personalDetails");

            for (let key of otherTabKeys) {
            const ref = componentRefs[key];
            if (ref?.current) {
              const saveFn = ref.current.update || (() => true);
              const result = await saveFn();
              if (!result || result.success === false) {
                const tabIndex = sections(employeeId).findIndex((sec) => sec.key === key);
                setActiveTab(tabIndex);
                setMessage(result?.message || `Failed to save ${key.replace(/([A-Z])/g, " $1").trim()}.`);
                setMessageType("error");
                setShowMessage(true);
                return false;
              }
            } else {
            }
          }
            // All success
            setMessage("All details saved successfully!");
            setMessageType("success");
            setShowMessage(true);
            setIsDirty(false);
            setOpenDialog(true);
            navigate("/material/EmpList");
        } catch (error) {
            console.error("Error saving details:", error);
            setMessage("An error occurred while saving details.");
            setMessageType("error");
            setShowMessage(true);
        }
      };
    
      const handleCloseDialog = () => {
        setOpenDialog(false);
        navigate(-1);  
      };

      const handleBackNavigation = () => {
      if (isDirty) {
        const confirmLeave = window.confirm("You have unsaved changes. Are you sure you want to go back?");
        if (!confirmLeave) return;
      }
      navigate(-1);
    };

    const handleTabChange = async (event, newValue) => {
      const currentTabKey = sections(employeeId)[activeTab]?.key;
      const currentRef = componentRefs[currentTabKey];

       if (newValue > activeTab && currentRef?.current) {
        try {
          const validateFn =
            currentRef.current.validatePersonal ||
            currentRef.current.validate ||
            (() => true);

          if (typeof validateFn === "function") {
            const isValid = await validateFn();

            if (!isValid) {
              setMessage(
                `Please complete ${currentTabKey.replace(/([A-Z])/g, " $1").trim()} before proceeding.`
              );
              setMessageType("error");
              setShowMessage(true);
              return;
            }
          }
        } catch (error) {
          console.error("Error validating tab:", currentTabKey, error);
          setMessage(
            `Error validating ${currentTabKey.replace(/([A-Z])/g, " $1").trim()}.`
          );
          setMessageType("error");
          setShowMessage(true);
          return;
        }
      }

      // Allow tab change (backward or forward after successful validation)
      setActiveTab(newValue);
    };


   


    if (!employeeId) {
      return (
        <Container maxWidth="lg" sx={{ mt: 6, mb: 8 }}>

          <Box sx={{ display: "flex", alignItems: "center", mb: 4,justifyContent: "space-between",flexWrap: "wrap",gap: 2, }}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <IconButton onClick={handleBackNavigation}>
                  <ArrowBackIcon fontSize="large" />
                </IconButton>
                <Typography variant="h3" fontWeight="bold" ml={2}>
                  Employee Details
                </Typography>
              </Box>
                <Button
                  variant="contained"
                  onClick={handleSave}
                  size="medium"
                  sx={{
                    bgcolor: "green",
                    color: "#fff",
                    fontSize: "1rem",
                    px: 6,
                    py: 1,
                    borderRadius: "8px",
                    fontWeight: "bold",
                    boxShadow: theme.shadows[4],
                    "&:hover": {
                      bgcolor: "#4caf50",
                    },
                  }}
                >
                  Submit
                </Button>
          </Box>

          {/* Tabs Styled like First Image */}
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              mb: 4,
              borderBottom: 1,
              borderColor: "divider",
              ".MuiTab-root": {
                textTransform: "none",
                fontWeight: 500,
                fontSize: "1rem",
                color: theme.palette.mode === "dark" ? "#b0b0b0" : "#333",
                minWidth: "100px",
                padding: "8px 16px",
                borderRadius: 0,
                transition: "none", 
                "&:hover": {
                  color: theme.palette.mode === "dark" ? "#b0b0b0" : "#333", 
                },
              },
              ".Mui-selected": {
                fontWeight: "bold",
                color: theme.palette.mode === "dark" ? "#fff !important" : "#000 !important",
                borderBottom: `3px solid ${theme.palette.mode === "dark" ? "#fff" : theme.palette.primary.main}`,
              },
              "& .MuiTabs-indicator": {
                backgroundColor: "transparent",   
              },
            }}
          >
            {sections(employeeId).map((section, index) => (
              <Tab key={index} label={section.label} />
            ))}
          </Tabs>

          {/* Tab Content */}
          <Box>
            {sections(employeeId).map(({ key, component: Component }, index) => (
              <div
                key={key}
                role="tabpanel"
                hidden={activeTab !== index}
                id={`tabpanel-${index}`}
                aria-labelledby={`tab-${index}`}
                style={{ display: activeTab === index ? "block" : "none" }}
              >
                <Component
                  ref={componentRefs[key]}
                  initialData={{
                    ...tempEmployeeData[key],
                    ...(key === "payrolldetails" && { corporate_email_id: corporateEmail }),
                  }}
                  handleFieldChange={handleFieldChange}
                  setIsDirty={setIsDirty}
                />
              </div>
            ))}
          </Box>

          {/* Success Dialog */}
          <Dialog open={openDialog} onClose={handleCloseDialog}>
            <DialogTitle sx={{ bgcolor: theme.palette.background.paper, color: theme.palette.text.primary }}>
              Success
            </DialogTitle>
            <DialogContent sx={{ bgcolor: theme.palette.background.paper }}>
              <DialogContentText sx={{ color: theme.palette.text.secondary }}>
                Employee details have been successfully added!
              </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ bgcolor: theme.palette.background.paper }}>
              <Button
                onClick={handleCloseDialog}
                autoFocus
                sx={{
                  bgcolor: theme.palette.primary.main,
                  color: "#fff",
                  "&:hover": {
                    bgcolor: theme.palette.primary.dark,
                  },
                }}
              >
                OK
              </Button>
            </DialogActions>
          </Dialog>
           <Snackbar
            open={showMessage}
            autoHideDuration={3000}
            onClose={() => setShowMessage(false)}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert
              onClose={() => setShowMessage(false)}
              severity={messageType}
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
        </Container>

      );
    }

    return (    
        <Container maxWidth="lg" sx={{ mt: 6, mb: 8 }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 4,justifyContent: "space-between",flexWrap: "wrap",gap: 2, }}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <IconButton onClick={handleBackNavigation}>
                  <ArrowBackIcon fontSize="large" />
                </IconButton>
                <Typography variant="h3" fontWeight="bold" ml={2}>
                  Employee Details
                </Typography>
              </Box>
                <Button
                  variant="contained"
                  onClick={handleUpdate}
                  size="medium"
                  sx={{
                    bgcolor: "green",
                    color: "#fff",
                    fontSize: "1rem",
                    px: 6,
                    py: 1,
                    borderRadius: "8px",
                    fontWeight: "bold",
                    boxShadow: theme.shadows[4],
                    "&:hover": {
                      bgcolor: "#4caf50",
                    },
                  }}
                >
                  Update
                </Button>
          </Box>
    
            <Tabs 
              value={activeTab} 
              onChange={handleTabChange} 
              variant="scrollable" 
              scrollButtons="auto"
              allowScrollButtonsMobile
              sx={{
                mb: 4,
                borderBottom: 1,
                borderColor: "divider",
                ".MuiTab-root": {
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: "1rem",
                  color: theme.palette.mode === "dark" ? "#b0b0b0" : "#333",
                  minWidth: "100px",
                  padding: "8px 16px",
                  borderRadius: 0,
                  transition: "none", 
                  "&:hover": {
                    color: theme.palette.mode === "dark" ? "#b0b0b0" : "#333", 
                  },
                },
                ".Mui-selected": {
                  fontWeight: "bold",
                  color: theme.palette.mode === "dark" ? "#fff !important" : "#000 !important",
                  borderBottom: `3px solid ${theme.palette.mode === "dark" ? "#fff" : theme.palette.primary.main}`,
                },
                "& .MuiTabs-indicator": {
                  backgroundColor: "transparent",   
                },
              }}
            >
              {sections(employeeId).map((section, index) => (
                <Tab key={index} label={section.label} />
              ))}
            </Tabs>

            <Box>
              {sections(employeeId).map(({ key, component: Component }, index) => (
                <div
                  key={key}
                  role="tabpanel"
                  hidden={activeTab !== index}
                  id={`tabpanel-${index}`}
                  aria-labelledby={`tab-${index}`}
                >
                    <Component
                      ref={componentRefs[key]}
                      initialData={{
                        ...tempEmployeeData[key],
                        ...(key === "payrolldetails" && { corporate_email_id: corporateEmail }),
                      }}
                      handleFieldChange={handleFieldChange}
                      setIsDirty={setIsDirty}
                    />
                </div>
              ))}
            </Box>
        
    
          <Dialog open={openDialog} onClose={handleCloseDialog}>
            <DialogTitle sx={{ bgcolor: theme.palette.mode === "dark" ? "white" : "#f5f5f5", color: theme.palette.mode === "dark" ? "white" : "black" }}>
              Success
            </DialogTitle>
            <DialogContent sx={{ bgcolor: theme.palette.mode === "dark" ? "white" : "#f5f5f5" }}>
              <DialogContentText sx={{ color: theme.palette.mode === "dark" ? "black" : "black" }}>
                Employee details have been successfully updated!
              </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ bgcolor: theme.palette.mode === "dark" ? "white" : "#f5f5f5" }}>
              <Button onClick={handleCloseDialog} sx={{
                bgcolor: "#446d9c",  
                color: "white",          
                '&:hover': {
                  bgcolor: "#9daab7", 
                },
              }} autoFocus>
                OK
              </Button>
            </DialogActions>
          </Dialog>
          <Snackbar
            open={showMessage}
            autoHideDuration={3000}
            onClose={() => setShowMessage(false)}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert
              onClose={() => setShowMessage(false)}
              severity={messageType}
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
        </Container>
        
      );
  };

  export default AddEmployee;